import { theme } from '@ui/styles/theme'

const newsCategoryColor = (category?: string | null) => {
  let color = ''
  switch (category) {
    case 'メディア掲載':
      color = '#179BBA'
      break
    case 'プレスリリース':
      color = theme.colors.primaryDark
      break
    case 'お知らせ':
    default:
      color = theme.colors.primary
      break
  }
  return color
}

export default newsCategoryColor
